module.exports = __webpack_public_path__ + "static/media/morgak.18c03615.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/morgak.jpeg
// module id = 48
// module chunks = 0